var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "con-exemple-prompt", attrs: { id: "resourceForm" } },
    [
      _c("div", { staticClass: "vx-row mb-6" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col sm:w-2/3 w-full" },
          [
            _vm.type != "show"
              ? _c("vs-input", {
                  staticClass: "w-full",
                  attrs: { name: "title", size: "large" },
                  model: {
                    value: _vm.resource.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.resource, "title", $$v)
                    },
                    expression: "resource.title",
                  },
                })
              : _c("b", [_vm._v(_vm._s(_vm.resource.title))]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vx-row mb-6" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col sm:w-2/3 w-full" },
          [
            _vm.type != "show"
              ? [
                  _c(
                    "div",
                    {
                      ref: "tooltip",
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": "top",
                        title:
                          "Cette donnée permet de catégoriser vos question. Vous pouvez sélectionner une valeur existante ou en ajouter une nouvelle.",
                      },
                    },
                    [
                      _c("TypeForm", {
                        attrs: { availableTypes: _vm.types.data },
                        model: {
                          value: _vm.resource.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.resource, "type", $$v)
                          },
                          expression: "resource.type",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _c("span", [_vm._v(_vm._s(_vm.resource.type))]),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c(
            "vs-collapse",
            { staticClass: "mb-6 mt-10", attrs: { accordion: "" } },
            [
              _c("vs-collapse-item", [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("h5", [_vm._v("Signification des réponses : ")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("0 - Pas du tout d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_0)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_0",
                              placeholder: "0 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_0,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_0", $$v)
                              },
                              expression: "resource.levels.level_0",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("1 - Plutôt pas d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_1)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_1",
                              placeholder: "1 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_1,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_1", $$v)
                              },
                              expression: "resource.levels.level_1",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("2 - Plutôt d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_2)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_2",
                              placeholder: "2 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_2,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_2", $$v)
                              },
                              expression: "resource.levels.level_2",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("3 - Tout à fait d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_3)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_3",
                              placeholder: " 3 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_3,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_3", $$v)
                              },
                              expression: "resource.levels.level_3",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-10" },
        [
          _vm.type != "show"
            ? _c("ItemsSelector", {
                attrs: {
                  label: "Questions associées",
                  availables: _vm.questions.data,
                  loading: _vm.questions.loading,
                  groupBy: (item) => item.type,
                  template: (item) => item.title,
                  searchBy: ["title"],
                  searchText: "Filtrer les questions disponibles",
                  dragText:
                    "Glissez-déposez les questions que vous souhaitez ajouter :",
                  availableText: "Questions disponibles",
                  selectedText: "Questions sélectionnées",
                  emptyText: "Aucune question n'a encore été créée",
                  addText: "Ajouter une nouvelle question",
                  addUrl: "/rh/referentiel/questions?create=true",
                },
                model: {
                  value: _vm.resource.questions,
                  callback: function ($$v) {
                    _vm.$set(_vm.resource, "questions", $$v)
                  },
                  expression: "resource.questions",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
      _c("span", [_vm._v("Libellé* :")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
      _c("span", [_vm._v("Type* :")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }